export default __webpack_public_path__ + "396e8d4dbd5bc48b0041f037e1e9a1d4.png";